<div class="template-container">
  <div class="template-nav">
    <ul mwc-menu [mwcSelectable]="true" class="template-menu" (mwcClick)="menuEvent($event)">
      <li mwc-menu-item mwcSelected>
        <a class="d-flex align-items-center justify-content-between w-100">
          <span class="menu-item-label">
            <span mwc-icon mwcIconfont="grid-01"></span>All Workflows
          </span>
          <mwc-tag [mwcColor]="'primary'" *ngIf="templatesCount['all']" style="margin:0">{{templatesCount['all']}}</mwc-tag>
        </a>
      </li>
      <li mwc-menu-item>
        <a class="d-flex align-items-center justify-content-between w-100">
          <span class="menu-item-label">
            <span mwc-icon mwcIconfont="star-02"></span>Favorites
          </span>
          <mwc-tag [mwcColor]="'gray'" *ngIf="favoritesCount" style="margin:0">{{favoritesCount}}</mwc-tag>
        </a>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub1" (mwcOpenChange)="openHandler('sub1')" mwcTitle="Marketing Function" [mwcIcon]="'dataflow-01'" (click)="getAllChildTemplateTypes('Marketing Function')" class="marketing-fun">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li  mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub2" (mwcOpenChange)="openHandler('sub2')" mwcTitle="Content Type" [mwcIcon]="'pen-tool-02'" (click)="getAllChildTemplateTypes('Content Type')">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub3" (mwcOpenChange)="openHandler('sub3')" mwcTitle="Funnel" [mwcIcon]="'filter-funnel-02'" (click)="getAllChildTemplateTypes('Funnel')">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li mwc-menu-item *ngIf="landingPageCustomEnabled">
        <a>
          <span mwc-icon mwcIconfont="settings-02"></span>Custom Templates
        </a>
      </li>
    </ul>
    <div class="custom-workflow-cta">
      <!-- <div class="custom-workflow-cta__icon">
        <span mwc-icon mwcIconfont="star-06"></span>
      </div> -->
      <div class="d-flex align-items-start gap-3">
        <div class="custom-workflow-cta__img">
          <img src="assets/images/cus-worflow.png" />
        </div>
        <div class="custom-workflow-cta__body">
          <p class="custom-workflow-cta__title">Need a custom workflow?</p>
          <p class="custom-workflow-cta__desc">Tailored automations designed around your marketing stack.</p>
        </div>
      </div>
      <button mwc-button mwcType="primary" mwcSize="small" mwcBlock class="custom-workflow-cta__action mwc-text-sm-regular">
        Get Started
        <span mwc-icon mwcIconfont="arrow-right" style="font-size:16px"></span>
      </button>
    </div>
  </div>
  <div class="template-sec">
    <mwc-spin [mwcIndicator]="customSpinTpl" [mwcSpinning]="isTemplateLoading">
      <div class="d-flex align-items-center justify-content-between mb-3 gap-3">
        <div class="mwc-text-lg-medium mwc-color-gray-900">{{selectedMenuValue}}</div>
        <div class="d-flex align-items-center gap-3">
          <span class="mwc-text-sm-medium">Filter by</span>
          <div>
            <mwc-select [mwcCustomTemplate]="defaultTemplate" [(ngModel)]="filterBy" (ngModelChange)="changeFilterBy($event)" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 180px;" [mwcOptionHeightPx]="36">
              <mwc-option mwcCustomContent mwcLabel="Recommended" mwcValue="recommended">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Recommended <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'recommended'"></span>
                </div>
              </mwc-option>
              <mwc-option mwcCustomContent mwcLabel="Recently used" mwcValue="recently-used">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Recently used <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'recently-used'"></span>
                </div>
              </mwc-option>
              <mwc-option mwcCustomContent mwcLabel="Alphabetical order " mwcValue="alphabetical-order">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Alphabetical order  <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'alphabetical-order'"></span>
                </div>
              </mwc-option>
              <!--<mwc-option mwcCustomContent mwcLabel="Custom Templates" mwcValue="custom-templates">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Custom Templates  <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'custom-templates'"></span>
                </div>
              </mwc-option>-->
            </mwc-select>
            <ng-template #defaultTemplate let-selected>
              {{selected.mwcLabel}}
            </ng-template>
          </div>
          <mwc-input-group [mwcPrefix]="prefixIconSearch" style="width: 220px;">
            <input mwc-input [formControl]="searchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearch()"  placeholder="Search" mwcSize="small" />
          </mwc-input-group>
          <ng-template #prefixIconSearch>
            <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
          </ng-template>
        </div>
      </div>
      
      <!-- Web Pages Banner Card -->
      <mwc-card *ngIf="showWebPagesCard" class="mb-3">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column" style="flex: 1;">
            <div class="mwc-text-lg-semibold mwc-color-gray-900" style="margin-bottom: 8px;">Web Pages</div>
            <div class="mwc-text-sm-regular mwc-color-gray-600" style="margin-bottom: 36px;">Webpage content generation made easy. Generate content for your entire website and all it's pages through a single workflow.</div>
            <button mwc-button mwcType="default" mwcSize="small" style="width: 105px;" (click)="openWebPagesWorkflow()">
              <span class="mwc-text-sm-medium">Get Started</span>
            </button>
          </div>
          <div class="d-flex align-items-center justify-content-center" style="flex: 0 0 250px;">
            <img src="assets/images/custom-template-01.jpg" alt="Web Pages" style="max-height: 100%; max-width: 100%; border-radius: 12px;">
          </div>
        </div>
      </mwc-card>
      
      <cdk-virtual-scroll-viewport #templateContainer itemSize="200" class="templates-container" [style.height]="containerHeight" *ngIf="showWebPagesCard == false">
        <div class="templates-row" *cdkVirtualFor="let row of rowedData">
          <div class="template-card" (click)="onSelect(template)" *ngFor="let template of row">
            <div class="template-card-heading">
              <div class="d-flex align-items-top justify-content-between w-100">
                <div class="featured-icon {{template.iconColor}}">
                  <span mwc-icon mwcIconfont={{template.icon}}></span>
                </div>
                <div class="template-card-actions" (click)="$event.stopPropagation()">
                  <span class="temp-star" mwc-tooltip [mwcTooltipTitle]="template.isFavorite ? 'Remove favorite' : 'Mark as favorite'" (click)="AddOrRemoveAsFav(template.templateId)" [ngClass]="template.isFavorite ? 'is-favorite' : 'is-default-favorite'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                      <path d="M10.2141 0.308206C10.3849 -0.10244 10.9666 -0.10244 11.1374 0.308207L13.7325 6.54757C13.8045 6.72069 13.9673 6.83897 14.1542 6.85396L20.8902 7.39397C21.3335 7.42951 21.5133 7.98277 21.1755 8.2721L16.0434 12.6683C15.901 12.7902 15.8388 12.9816 15.8823 13.164L17.4503 19.7371C17.5535 20.1697 17.0828 20.5117 16.7033 20.2798L10.9364 16.7574C10.7764 16.6597 10.5752 16.6597 10.4152 16.7574L4.64827 20.2798C4.26872 20.5117 3.79809 20.1697 3.90129 19.7371L5.46922 13.164C5.51272 12.9816 5.45053 12.7902 5.30814 12.6683L0.176081 8.2721C-0.161688 7.98277 0.0180759 7.42951 0.461403 7.39397L7.19732 6.85396C7.38422 6.83897 7.54702 6.72069 7.61902 6.54757L10.2141 0.308206Z"/>
                    </svg>
                  </span>
                  <button mwc-button mwcType="default" mwcSize="small" class="template-card-actions__view" title="View details" (click)="viewDetailsEvent(template)">
                    <span mwc-icon mwcIconfont="eye"></span>
                  </button>
                </div>
              </div>
              <div class="template-card-title mwc-text-sm-medium mwc-color-gray-800"> 
                {{template.title}} 
                <mwc-tag *ngIf="template.isRecommended" class="tag" mwcColor="primary" style="margin-left: 8px;margin-right: 0;">Recommended</mwc-tag>
              </div>
            </div>
            <div class="mwc-text-xs-regular mwc-color-gray-600 template-card-desc"> {{template.description}} </div>
            <div class="d-flex align-items-center justify-content-between w-100">
              <div class="template-card-stat mwc-text-xs-medium mwc-color-gray-700 d-flex align-items-center">
                <mwc-tag [mwcColor]="'gray'">Email</mwc-tag>
                <mwc-tag [mwcColor]="'gray'">Long Form</mwc-tag>
              </div>
              <button mwc-button mwcType="primary" mwcSize="small" (click)="initializeNewArticle('AI', template)" class="template-card-start-btn">
                <span class="mwc-text-sm-medium">Start</span>
                <span mwc-icon mwcIconfont="arrow-right" style="font-size:16px"></span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="noTemplateExist">
          <div class="empty-state-msg" style="text-align: center;">
            <div class="image-center">
              <img src="assets/images/Illustration-search1.svg">
            </div>
            <div>
              <div class="mwc-text-lg-medium  mwc-color-gray-900 mb-2">No templates found</div>
              <div class="mwc-text-sm-regular mwc-color-gray-600">We cannot find anything related to your search, <br /> please search something else or select from the menu.</div>
            </div>
          </div>
        </div>
        <div *ngIf="childTemplates.length == 0 && selectedMenuValue == 'Favorites'">
          <div class="empty-state-msg" style="text-align: center;">
            <div class="image-center">
              <img src="assets/images/Illustration-nofavorites.svg">
            </div>
            <div>
              <div class="mwc-text-lg-medium  mwc-color-gray-900 mb-2">No favorites yet</div>
              <div class="mwc-text-sm-regular mwc-color-gray-600">Simply click on the star icon on template page to add any template into <br /> your favorites. </div>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </mwc-spin>
  </div>
</div>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

